<div class="avatar-container" [ngStyle]="hostStyle">

    @if(showGenericAvatar) {
        <div class="generic-avatar-content header-reg-l" 
            [style.width.px]="size()" 
            [style.height.px]="size()">
            {{ initialsLettersAvatarText }}
        </div>
    } @else {
        <div class="avatar-content" [ngStyle]="avatarStyle">
            {{ avatarText }}
        </div>
    }

</div>
